import React, { useState } from 'react';
import { Box, TextField, Button, Typography } from '@mui/material';
import { forgetpassword, resetpassword } from '../../components/Apis';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router';
import { useDropdownStyle } from '../../hooks/useDropdownStyle';
import { useTranslation } from 'react-i18next';
const Forget = () => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [showResetForm, setShowResetForm] = useState(false);
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [otp, setotp] = useState('');
  const [signature, setsignature] = useState('');
  console.log(signature)
  console.log(otp)
  const navigate = useNavigate();
  const { inputStyle, iputType } = useDropdownStyle();
  const { t, i18n } = useTranslation();



  const handlePhoneSubmit = async (e) => {
    e.preventDefault();

    // استدعاء دالة forgetpassword للتحقق من رقم الهاتف
    const response = await forgetpassword(phoneNumber);
    if (response.response?.data?.success === false) {
      Swal.fire({
        icon: 'error', // لتحديد رمز الخطأ
        title: t('error'),
        text: response.response.data.message || t('error'),
        confirmButtonText: t('ok'),
      });

    }
    console.log(response)


    if (response?.success) {
      setShowResetForm(true); // الانتقال إلى فورم تغيير كلمة المرور
      setotp(response.data.otp)
      setsignature(response.data.signature)
    } else {
      //   alert('Invalid phone number or not registered.');
    }
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      alert('Passwords do not match!');
      return;
    }
    const obj = {
      "signature": signature,
      "otp": `${otp}`,
      "password_confirmation": confirmPassword,
      "password": newPassword,
      // phone_number: phoneNumber
    }
    console.log(obj)
    const response = await resetpassword(obj);
    console.log(response)
    if (response.success) {
      Swal.fire(t('success'))
      navigate('/');
      localStorage.removeItem('token');
      localStorage.removeItem('refreshtoken');

      console.log('Password reset successful:', { phoneNumber, newPassword });
    }


    // استدعاء API لتغيير كلمة المرور هنا
    // alert('Your password has been reset successfully.');
  };

  return (
    <Box sx={{ width: '40%', margin: '2% auto', textAlign: 'center' }}>
      {showResetForm ? (
        // نموذج تغيير كلمة المرور
        <>
          <Typography variant="h4" sx={{ marginBottom: '20px', fontWeight: 'bold' }}>
            Reset Password
          </Typography>
          <form onSubmit={handlePasswordSubmit}>
            <TextField
              label="New Password"
              type="password"
              variant="outlined"
              fullWidth
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              margin="normal"
            />
            <TextField
              label="Confirm Password"
              type="password"
              variant="outlined"
              fullWidth
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              margin="normal"
            />
            <Button
              type="submit"
              variant="contained"
              sx={{
                backgroundColor: '#C47D60',
                color: 'white',
                marginTop: '20px',
                padding: '10px 20px',
                fontSize: '16px',
                fontWeight: 'bold',
                '&:hover': {
                  backgroundColor: '#A65A42',
                },
              }}
            >
              Reset Password
            </Button>
          </form>
        </>
      ) : (
        // نموذج إدخال رقم الهاتف
        <>
          <Typography variant="h4" sx={{ marginBottom: '20px', fontWeight: 'bold' }}>
            {t('forgetPassword')}
          </Typography>
          <Typography variant="body1" sx={{ marginBottom: '20px', color: 'gray' }}>
            {t('forgetPasswordtext')}
          </Typography>
          <form onSubmit={handlePhoneSubmit}>
            <TextField
              label={t('phoneNumber')}
              variant="outlined"
              fullWidth
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              margin="normal"
              inputProps={iputType}
              dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
              sx={inputStyle}
            />
            <Button
              type="submit"
              variant="contained"
              sx={{
                backgroundColor: '#C47D60',
                color: 'white',
                marginTop: '20px',
                padding: '10px 20px',
                fontSize: '16px',
                fontWeight: 'bold',
                '&:hover': {
                  backgroundColor: '#A65A42',
                },
              }}
            >
              {t('submit')}
            </Button>
          </form>
        </>
      )}
    </Box>
  );
};

export default Forget;
